module.exports = __webpack_public_path__ + "assets/77adf0e6ff12bc4c7a687841831a9a93.svg";